module.exports = __webpack_public_path__ + "img/farming_26.1621f293.png";